import {
    needsPhoneSetup,
    needsPhoneVerification,
    needsTOTPSetup,
    needsTOTPVerification,
} from '../../state/Auth.selectors';

import UnauthenticatedPaths from '../../../routing/UnauthenticatedRoutes/UnauthenticatedRoutes.paths';
import { matchPath } from 'react-router-dom';

export const mapStateToProps = state => {
    return {
        needsPhoneSetup:
            !matchPath(location.pathname, {
                path: `${UnauthenticatedPaths.SELECT_MFA}/setup-phone`,
            }) && needsPhoneSetup(state),
        needsTOTPSetup:
            !matchPath(location.pathname, {
                path: `${UnauthenticatedPaths.SELECT_MFA}/setup-totp`,
            }) && needsTOTPSetup(state),
        needsPhoneVerification:
            !matchPath(location.pathname, {
                path: `${UnauthenticatedPaths.SELECT_MFA}/verify-phone`,
            }) && needsPhoneVerification(state),
        needsTOTPVerification:
            !matchPath(location.pathname, {
                path: `${UnauthenticatedPaths.SELECT_MFA}/verify-totp`,
            }) && needsTOTPVerification(state),
    };
};

export const mapDispatchToProps = {};
